/**
 * Path-based SPA router for home (/) and app pages (/app/:id).
 * Firebase Hosting already rewrites unknown paths to index.html.
 */

function parseRoute(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const appMatch = path.match(/^\/app\/([^/]+)$/);
  if (appMatch) {
    return { name: "app", appId: decodeURIComponent(appMatch[1]) };
  }
  return { name: "home" };
}

export function getRoute() {
  return parseRoute(window.location.pathname);
}

export function navigate(to, { replace = false } = {}) {
  const url = to.startsWith("/") ? to : `/${to}`;
  if (replace) {
    history.replaceState({}, "", url);
  } else {
    history.pushState({}, "", url);
  }
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function startRouter(onRoute) {
  const handle = () => onRoute(getRoute());
  window.addEventListener("popstate", handle);
  handle();
  return () => window.removeEventListener("popstate", handle);
}
